import { QuoteLocationSurchargeBase } from "./quote-location-surcharge-base.model";
import { Quote } from "../../quote.type";

export class LclQuoteLocationSurcharge extends QuoteLocationSurchargeBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    public name: string,
    public internalNote: string,
    private weightPrice: number,
    private measurementPrice: number,
    private shipmentPrice: number,
    private piecePrice: number,
    private documentPrice: number,
    public quote: Quote,
  ) {
    super(id, discriminator, name, internalNote, quote);
  }

  public getWeightPrice(): number {
    return this.weightPrice;
  }

  public setWeightPrice(param: number) {
    this.weightPrice = param;
  }

  public getMeasurementPrice(): number {
    return this.measurementPrice;
  }

  public setMeasurementPrice(param: number) {
    this.measurementPrice = param;
  }

  public getShipmentPrice(): number {
    return this.shipmentPrice;
  }

  public setShipmentPrice(param: number) {
    this.shipmentPrice = param;
  }

  public getPiecePrice(): number {
    return this.piecePrice;
  }

  public setPiecePrice(param: number) {
    this.piecePrice = param;
  }

  public getDocumentPrice(): number {
    return this.documentPrice;
  }

  public setDocumentPrice(param: number) {
    this.documentPrice = param;
  }

  public setLclValue(fieldType: string, val: number): void {
    this[fieldType] = val;
  }

  public hasAllValues(param: string[] = []): boolean {
    return (
      null !== this.getWeightPrice() &&
      null !== this.getMeasurementPrice() &&
      null !== this.getShipmentPrice()
    );
  }
}
